var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigcontact6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_6556)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.9658,
    y1: 120.093,
    x2: 17.9658,
    y2: -21.4222,
    stroke: "url(#paint0_linear_75_6556)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.9658,
    y1: 120.093,
    x2: 52.9658,
    y2: -21.4222,
    stroke: "url(#paint1_linear_75_6556)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.9658,
    y1: 120.093,
    x2: 88.9658,
    y2: -21.4222,
    stroke: "url(#paint2_linear_75_6556)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.966,
    y1: 120.093,
    x2: 124.966,
    y2: -21.4222,
    stroke: "url(#paint3_linear_75_6556)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.966,
    y1: 120.093,
    x2: 160.966,
    y2: -21.4222,
    stroke: "url(#paint4_linear_75_6556)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.966,
    y1: 120.093,
    x2: 195.966,
    y2: -21.4222,
    stroke: "url(#paint5_linear_75_6556)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.966,
    y1: 120.093,
    x2: 231.966,
    y2: -21.4222,
    stroke: "url(#paint6_linear_75_6556)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 18.954,
    x2: 258.387,
    y2: 18.954,
    stroke: "url(#paint7_linear_75_6556)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 77.954,
    x2: 258.387,
    y2: 77.954,
    stroke: "url(#paint8_linear_75_6556)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 47.954,
    x2: 258.387,
    y2: 47.954,
    stroke: "url(#paint9_linear_75_6556)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.125,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "url(#paint10_linear_75_6556)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_75_6556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0581 51.8101C56.1152 51.8101 55.2109 52.1846 54.5442 52.8513C53.8775 53.5181 53.5029 54.4223 53.5029 55.3652C53.5029 56.3081 53.8775 57.2123 54.5442 57.8791C55.2109 58.5458 56.1152 58.9203 57.0581 58.9203C58.001 58.9203 58.9052 58.5458 59.5719 57.8791C60.2387 57.2123 60.6132 56.3081 60.6132 55.3652C60.6132 54.4223 60.2387 53.5181 59.5719 52.8513C58.9052 52.1846 58.001 51.8101 57.0581 51.8101Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4678 47.6623C40.4678 46.0254 41.795 44.6997 43.4304 44.6997H70.6865C72.3219 44.6997 73.6491 46.027 73.6491 47.6623V63.0679C73.6491 64.7049 72.3219 66.0306 70.6865 66.0306H43.4304C43.0413 66.0306 42.6561 65.9539 42.2966 65.8051C41.9372 65.6562 41.6106 65.4379 41.3355 65.1628C41.0604 64.8877 40.8422 64.5611 40.6933 64.2017C40.5444 63.8423 40.4678 63.457 40.4678 63.0679V47.6623ZM51.1332 55.3651C51.1332 53.7937 51.7575 52.2866 52.8687 51.1754C53.9799 50.0642 55.487 49.4399 57.0584 49.4399C58.6299 49.4399 60.137 50.0642 61.2482 51.1754C62.3594 52.2866 62.9837 53.7937 62.9837 55.3651C62.9837 56.9366 62.3594 58.4437 61.2482 59.5549C60.137 60.6661 58.6299 61.2904 57.0584 61.2904C55.487 61.2904 53.9799 60.6661 52.8687 59.5549C51.7575 58.4437 51.1332 56.9366 51.1332 55.3651ZM67.7239 54.1801C67.4096 54.1801 67.1082 54.3049 66.8859 54.5272C66.6637 54.7494 66.5388 55.0508 66.5388 55.3651V55.3778C66.5388 56.0319 67.0697 56.5628 67.7239 56.5628H67.7365C68.0508 56.5628 68.3522 56.438 68.5745 56.2157C68.7967 55.9935 68.9216 55.6921 68.9216 55.3778V55.3651C68.9216 55.0508 68.7967 54.7494 68.5745 54.5272C68.3522 54.3049 68.0508 54.1801 67.7365 54.1801H67.7239ZM45.208 55.3651C45.208 55.0508 45.3328 54.7494 45.5551 54.5272C45.7773 54.3049 46.0787 54.1801 46.393 54.1801H46.4057C46.7199 54.1801 47.0214 54.3049 47.2436 54.5272C47.4658 54.7494 47.5907 55.0508 47.5907 55.3651V55.3778C47.5907 55.6921 47.4658 55.9935 47.2436 56.2157C47.0214 56.438 46.7199 56.5628 46.4057 56.5628H46.393C46.0787 56.5628 45.7773 56.438 45.5551 56.2157C45.3328 55.9935 45.208 55.6921 45.208 55.3778V55.3651Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_75_6556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.6306 67.648C70.6306 67.8054 70.5681 67.9564 70.4568 68.0677C70.3455 68.179 70.1945 68.2415 70.0371 68.2415C69.8797 68.2415 69.7288 68.179 69.6175 68.0677C69.5062 67.9564 69.4436 67.8054 69.4436 67.648C69.4436 67.4906 69.5062 67.3397 69.6175 67.2284C69.7288 67.1171 69.8797 67.0546 70.0371 67.0546C70.1945 67.0546 70.3455 67.1171 70.4568 67.2284C70.5681 67.3397 70.6306 67.4906 70.6306 67.648ZM66.4763 70.0219C66.6337 70.0219 66.7846 69.9594 66.8959 69.8481C67.0072 69.7368 67.0698 69.5858 67.0698 69.4284C67.0698 69.271 67.0072 69.1201 66.8959 69.0088C66.7846 68.8975 66.6337 68.835 66.4763 68.835C66.3189 68.835 66.1679 68.8975 66.0566 69.0088C65.9453 69.1201 65.8828 69.271 65.8828 69.4284C65.8828 69.5858 65.9453 69.7368 66.0566 69.8481C66.1679 69.9594 66.3189 70.0219 66.4763 70.0219ZM67.0698 71.2089C67.0698 71.3663 67.0072 71.5172 66.8959 71.6285C66.7846 71.7398 66.6337 71.8023 66.4763 71.8023C66.3189 71.8023 66.1679 71.7398 66.0566 71.6285C65.9453 71.5172 65.8828 71.3663 65.8828 71.2089C65.8828 71.0515 65.9453 70.9005 66.0566 70.7892C66.1679 70.6779 66.3189 70.6154 66.4763 70.6154C66.6337 70.6154 66.7846 70.6779 66.8959 70.7892C67.0072 70.9005 67.0698 71.0515 67.0698 71.2089ZM68.2567 70.0219C68.4141 70.0219 68.565 69.9594 68.6763 69.8481C68.7876 69.7368 68.8502 69.5858 68.8502 69.4284C68.8502 69.271 68.7876 69.1201 68.6763 69.0088C68.565 68.8975 68.4141 68.835 68.2567 68.835C68.0993 68.835 67.9483 68.8975 67.837 69.0088C67.7258 69.1201 67.6632 69.271 67.6632 69.4284C67.6632 69.5858 67.7258 69.7368 67.837 69.8481C67.9483 69.9594 68.0993 70.0219 68.2567 70.0219ZM68.8502 71.2089C68.8502 71.3663 68.7876 71.5172 68.6763 71.6285C68.565 71.7398 68.4141 71.8023 68.2567 71.8023C68.0993 71.8023 67.9483 71.7398 67.837 71.6285C67.7258 71.5172 67.6632 71.3663 67.6632 71.2089C67.6632 71.0515 67.7258 70.9005 67.837 70.7892C67.9483 70.6779 68.0993 70.6154 68.2567 70.6154C68.4141 70.6154 68.565 70.6779 68.6763 70.7892C68.7876 70.9005 68.8502 71.0515 68.8502 71.2089ZM70.0371 70.0219C70.1945 70.0219 70.3455 69.9594 70.4568 69.8481C70.5681 69.7368 70.6306 69.5858 70.6306 69.4284C70.6306 69.271 70.5681 69.1201 70.4568 69.0088C70.3455 68.8975 70.1945 68.835 70.0371 68.835C69.8797 68.835 69.7288 68.8975 69.6175 69.0088C69.5062 69.1201 69.4436 69.271 69.4436 69.4284C69.4436 69.5858 69.5062 69.7368 69.6175 69.8481C69.7288 69.9594 69.8797 70.0219 70.0371 70.0219ZM70.6306 71.2089C70.6306 71.3663 70.5681 71.5172 70.4568 71.6285C70.3455 71.7398 70.1945 71.8023 70.0371 71.8023C69.8797 71.8023 69.7288 71.7398 69.6175 71.6285C69.5062 71.5172 69.4436 71.3663 69.4436 71.2089C69.4436 71.0515 69.5062 70.9005 69.6175 70.7892C69.7288 70.6779 69.8797 70.6154 70.0371 70.6154C70.1945 70.6154 70.3455 70.6779 70.4568 70.7892C70.5681 70.9005 70.6306 71.0515 70.6306 71.2089ZM71.8175 70.0219C71.9749 70.0219 72.1259 69.9594 72.2372 69.8481C72.3485 69.7368 72.411 69.5858 72.411 69.4284C72.411 69.271 72.3485 69.1201 72.2372 69.0088C72.1259 68.8975 71.9749 68.835 71.8175 68.835C71.6601 68.835 71.5092 68.8975 71.3979 69.0088C71.2866 69.1201 71.224 69.271 71.224 69.4284C71.224 69.5858 71.2866 69.7368 71.3979 69.8481C71.5092 69.9594 71.6601 70.0219 71.8175 70.0219ZM72.411 71.2089C72.411 71.3663 72.3485 71.5172 72.2372 71.6285C72.1259 71.7398 71.9749 71.8023 71.8175 71.8023C71.6601 71.8023 71.5092 71.7398 71.3979 71.6285C71.2866 71.5172 71.224 71.3663 71.224 71.2089C71.224 71.0515 71.2866 70.9005 71.3979 70.7892C71.5092 70.6779 71.6601 70.6154 71.8175 70.6154C71.9749 70.6154 72.1259 70.6779 72.2372 70.7892C72.3485 70.9005 72.411 71.0515 72.411 71.2089ZM73.5979 70.0219C73.7553 70.0219 73.9063 69.9594 74.0176 69.8481C74.1289 69.7368 74.1914 69.5858 74.1914 69.4284C74.1914 69.271 74.1289 69.1201 74.0176 69.0088C73.9063 68.8975 73.7553 68.835 73.5979 68.835C73.4405 68.835 73.2896 68.8975 73.1783 69.0088C73.067 69.1201 73.0045 69.271 73.0045 69.4284C73.0045 69.5858 73.067 69.7368 73.1783 69.8481C73.2896 69.9594 73.4405 70.0219 73.5979 70.0219ZM72.411 67.648C72.411 67.8054 72.3485 67.9564 72.2372 68.0677C72.1259 68.179 71.9749 68.2415 71.8175 68.2415C71.6601 68.2415 71.5092 68.179 71.3979 68.0677C71.2866 67.9564 71.224 67.8054 71.224 67.648C71.224 67.4906 71.2866 67.3397 71.3979 67.2284C71.5092 67.1171 71.6601 67.0546 71.8175 67.0546C71.9749 67.0546 72.1259 67.1171 72.2372 67.2284C72.3485 67.3397 72.411 67.4906 72.411 67.648ZM73.5979 68.2415C73.7553 68.2415 73.9063 68.179 74.0176 68.0677C74.1289 67.9564 74.1914 67.8054 74.1914 67.648C74.1914 67.4906 74.1289 67.3397 74.0176 67.2284C73.9063 67.1171 73.7553 67.0546 73.5979 67.0546C73.4405 67.0546 73.2896 67.1171 73.1783 67.2284C73.067 67.3397 73.0045 67.4906 73.0045 67.648C73.0045 67.8054 73.067 67.9564 73.1783 68.0677C73.2896 68.179 73.4405 68.2415 73.5979 68.2415Z",
    fill: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.309 59.5069L67.0098 58.8061C67.3087 59.1049 67.4766 59.5102 67.4766 59.9328V60.1198H72.5982V59.9328C72.5982 59.5102 72.7661 59.1049 73.0649 58.8061M66.309 59.5069L73.0649 58.8061M66.309 59.5069L67.0098 58.8061C66.711 58.5072 66.3057 58.3394 65.8831 58.3394C65.4605 58.3394 65.0552 58.5072 64.7563 58.8061L65.449 59.4987L64.7563 58.8061C64.4575 59.1049 64.2896 59.5102 64.2896 59.9328V60.1443C63.5446 60.2347 62.8466 60.5718 62.3105 61.108C61.6777 61.7407 61.3223 62.5988 61.3223 63.4936V72.3957C61.3223 73.2905 61.6777 74.1487 62.3105 74.7814L62.3105 74.7814C62.9432 75.4141 63.8013 75.7696 64.6961 75.7696H75.3786C76.2734 75.7696 77.1316 75.4141 77.7643 74.7814L77.0572 74.0743L77.7643 74.7814C78.397 74.1487 78.7525 73.2905 78.7525 72.3957V63.4936C78.7525 62.5988 78.397 61.7407 77.7643 61.108L77.1043 61.7679L77.7643 61.108C77.2282 60.5718 76.5302 60.2347 75.7851 60.1443V59.9328C75.7851 59.5102 75.6173 59.1049 75.3184 58.8061C75.0196 58.5072 74.6143 58.3394 74.1917 58.3394C73.7691 58.3394 73.3638 58.5072 73.0649 58.8061M66.309 59.5069L73.0649 58.8061M75.5108 66.3288C75.5459 66.3639 75.5656 66.4114 75.5656 66.461V72.3957C75.5656 72.4453 75.5459 72.4928 75.5108 72.5279C75.4757 72.563 75.4282 72.5826 75.3786 72.5826H64.6961C64.6466 72.5826 64.599 72.563 64.564 72.5279C64.5289 72.4928 64.5092 72.4453 64.5092 72.3957V66.461C64.5092 66.4114 64.5289 66.3639 64.564 66.3288C64.599 66.2938 64.6466 66.2741 64.6961 66.2741H75.3786C75.4282 66.2741 75.4757 66.2938 75.5108 66.3288Z",
    fill: "#C1D6FF",
    stroke: "#F5F8FF",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.125,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "url(#paint11_linear_75_6556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7464 212.625V210.46H19.527V197.669H17.1161V212.625H28.7464ZM35.975 212.848C39.6806 212.848 42.1585 210.504 42.1585 207.089C42.1585 203.629 39.6806 201.307 35.975 201.307C32.2917 201.307 29.8139 203.629 29.8139 207.089C29.8139 210.504 32.2917 212.848 35.975 212.848ZM35.975 210.705C33.2963 210.705 32.1801 209.433 32.1801 207.089C32.1801 204.723 33.2963 203.428 35.975 203.428C38.6761 203.428 39.7923 204.723 39.7923 207.089C39.7923 209.433 38.6761 210.705 35.975 210.705ZM47.1672 212.848C49.6897 212.848 51.4532 211.732 52.0336 209.857H52.1899V212.625H54.3998V205.883C54.3998 203.227 52.8149 201.307 49.2879 201.307C45.7608 201.307 43.6625 203.205 43.6625 205.727V205.817H46.051V205.727C46.051 204.098 47.0556 203.428 49.1093 203.428C51.23 203.428 52.0336 204.075 52.0336 205.906V206.553L46.9886 207.089C44.801 207.334 43.4169 208.227 43.4169 209.946C43.4169 211.777 44.8679 212.848 47.1672 212.848ZM45.8278 209.79C45.8278 208.919 46.4305 208.629 47.6806 208.473L52.0336 207.982C52.0336 210.169 50.3371 211.107 47.8146 211.107C46.4305 211.107 45.8278 210.683 45.8278 209.79ZM58.9628 212.625V207.134C58.9628 204.723 60.0566 203.473 62.4898 203.473C64.7891 203.473 65.7266 204.522 65.7266 206.598V212.625H68.1375V205.95C68.1375 203.383 66.6196 201.307 63.539 201.307C60.7263 201.307 59.253 203.093 58.9181 204.968H58.7619V201.53H56.5519V212.625H58.9628ZM75.5316 212.848C78.6568 212.848 80.7106 211.62 80.7106 209.544C80.7106 207.714 79.5051 206.821 76.871 206.486L74.3039 206.129C72.6297 205.906 72.1832 205.593 72.1832 204.723C72.1832 203.673 72.8975 203.227 74.9289 203.227C77.3844 203.227 78.0541 203.919 78.0541 205.236V205.37H80.4427V205.303C80.4427 202.669 78.389 201.307 74.9959 201.307C71.5805 201.307 69.817 202.691 69.817 204.633C69.817 206.486 71.0894 207.379 73.1877 207.647L76.2236 208.049C77.8086 208.272 78.3443 208.562 78.3443 209.477C78.3443 210.46 77.697 210.906 75.5316 210.906C73.21 210.906 72.3395 210.437 72.3395 208.986V208.808H69.9286V208.875C69.9286 211.442 71.96 212.848 75.5316 212.848Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_6556",
    x1: 18.4658,
    y1: -1.34432,
    x2: 18.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_6556",
    x1: 53.4658,
    y1: -1.34432,
    x2: 53.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_6556",
    x1: 89.4658,
    y1: -1.34432,
    x2: 89.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_6556",
    x1: 125.466,
    y1: -1.34432,
    x2: 125.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_6556",
    x1: 161.466,
    y1: -1.34432,
    x2: 161.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_6556",
    x1: 196.466,
    y1: -1.34432,
    x2: 196.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_6556",
    x1: 232.466,
    y1: -1.34432,
    x2: 232.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_6556",
    x1: 0,
    y1: 19.454,
    x2: 255.154,
    y2: 19.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_6556",
    x1: 0,
    y1: 78.454,
    x2: 255.154,
    y2: 78.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_75_6556",
    x1: 0,
    y1: 48.454,
    x2: 255.154,
    y2: 48.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_75_6556",
    x1: 60,
    y1: 16.625,
    x2: 60,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_75_6556",
    x1: 60,
    y1: 16.625,
    x2: 60,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6556"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_75_6556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(39 39.625)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_75_6556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.9911,
    height: 18.9911,
    fill: "white",
    transform: "translate(60.542 57.559)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigcontact6);
export default __webpack_public_path__ + "static/media/bigcontact6.d710b84799058ec66512a565f1fc89f1.svg";
export { ForwardRef as ReactComponent };